import React from 'react';
import { Zap, ToggleLeft, Clock } from 'lucide-react';

const recipes = [
  {
    title: 'Auto-create Trello cards',
    description: 'Whenever a new WhatsApp thread starts, create a Trello card in Intake list.',
    status: 'enabled',
    updatedAt: '2h ago',
  },
  {
    title: 'Tag dormant conversations',
    description: 'Add the "Follow-up" label if no reply after 48 hours.',
    status: 'paused',
    updatedAt: '1d ago',
  },
];

export const AutomationPage: React.FC = () => {
  return (
    <div className="page-section">
      <header className="page-heading">
        <div>
          <p className="eyebrow">Playbooks</p>
          <h2>Automation recipes</h2>
        </div>
      </header>

      <div className="automation-grid">
        {recipes.map((recipe) => (
          <article key={recipe.title} className="panel">
            <header className="panel-header">
              <div>
                <p className="eyebrow">
                  <Zap size={16} /> Automation
                </p>
                <h3>{recipe.title}</h3>
              </div>
              <button className={`pill ${recipe.status === 'enabled' ? 'success' : 'muted'}`}>
                {recipe.status}
              </button>
            </header>
            <p>{recipe.description}</p>
            <footer className="panel-footer">
              <span>
                <Clock size={14} />
                Updated {recipe.updatedAt}
              </span>
              <button className="ghost-button">
                <ToggleLeft size={16} />
                Configure
              </button>
            </footer>
          </article>
        ))}
      </div>
    </div>
  );
};
